import axios from './axiosSRP';

export const apiLottoAssistantConversation = async ({
  unitToken,
  prompt,
  conversationId = null,
  metadata = null,
  activity = 0,
}) => {
  const { data } = await axios.post('lotteries/assistant/conversation', {
    token: unitToken,
    prompt,
    conversation_id: conversationId,
    metadata,
    activity,
  });
  return data?.assistant_conversation_response ?? data;
};

export const apiLottoAssistantEvent = async ({
  unitToken,
  conversationId,
  event,
}) => {
  const { data } = await axios.post('lotteries/assistant/event', {
    token: unitToken,
    conversation_id: conversationId,
    event,
  });
  return data;
};

export const apiGetUpcomingLotteries = async ({
  unitToken,
  country,
  lotteryName,
  format,
  onlyWithBonusBall,
  limit,
  withSuggestedOptions,
}) => {
  const params = { token: unitToken };
  if (country) params.country = country;
  if (lotteryName) params.lottery_name = lotteryName;
  if (format) params.format = format;
  if (onlyWithBonusBall) params.with_bonus_ball = onlyWithBonusBall;
  if (limit) params.limit = limit;
  if (withSuggestedOptions) params.with_suggested_markets = withSuggestedOptions;

  const { data } = await axios.get('lotteries/upcoming', { params });
  return data;
};

export const apiGetBettingOptions = async ({ unitToken, lotteryId }) => {
  const { data } = await axios.get(`lotteries/${lotteryId}/betting_options`, {
    params: { token: unitToken },
  });
  return data?.lottery_betting_options ?? data;
};

export const apiGetQuickPick = async ({
  unitToken,
  stake,
  country,
  lotteryName,
  format,
}) => {
  const params = { token: unitToken };
  if (stake) params.stake = stake;
  if (country) params.country = country;
  if (lotteryName) params.lottery_name = lotteryName;
  if (format) params.format = format;

  const { data } = await axios.get('lotteries/quick_pick', { params });
  return data;
};

export const apiGetSuggestedBets = async ({ unitToken, stake }) => {
  const params = { token: unitToken };
  if (stake) params.stake = stake;

  const { data } = await axios.get('lotteries/suggested_bets', { params });
  return data;
};

export const apiGetLotteryResults = async ({
  unitToken,
  country,
  lotteryName,
  from,
  to,
}) => {
  const params = { token: unitToken };
  if (country) params.country = country;
  if (lotteryName) params.lottery_name = lotteryName;
  if (from) params.from = from;
  if (to) params.to = to;

  const { data } = await axios.get('lotteries/results', { params });
  return data;
};

export const apiGetLotteryDetailedResults = async ({
  unitToken,
  lotteryId,
  limit,
  before,
  from,
  to,
}) => {
  const params = { token: unitToken };
  if (limit) params.limit = limit;
  if (before) params.before = before;
  if (from) params.from = from;
  if (to) params.to = to;

  const { data } = await axios.get(`lotteries/${lotteryId}/results`, {
    params,
  });
  return data;
};

export const apiGetHotColdNumbers = async ({ unitToken, lotteryId }) => {
  const { data } = await axios.get(
    `lotteries/${lotteryId}/hot_cold_numbers`,
    { params: { token: unitToken } }
  );
  return data;
};

export const apiRegisterBets = async ({ unitToken, wagers }) => {
  const { data } = await axios.post('lotteries/register_bets', {
    token: unitToken,
    wagers,
  });
  return data;
};

export const apiGetPlayerBets = async ({
  unitToken,
  cursor,
  limit,
  status,
  from,
  to,
}) => {
  const params = { token: unitToken };
  if (cursor) params.cursor = cursor;
  if (limit) params.limit = limit;
  if (status) params.status = status;
  if (from != null) params.from = from;
  if (to != null) params.to = to;

  const { data } = await axios.get('lotteries/player_bets', { params });
  return data;
};

export const apiGetPlayerTickets = async ({
  unitToken,
  cursor,
  limit,
  from,
  to,
}) => {
  const params = { token: unitToken, status: 'tickets' };
  if (cursor) params.cursor = cursor;
  if (limit) params.limit = limit;
  if (from != null) params.from = from;
  if (to != null) params.to = to;

  const { data } = await axios.get('lotteries/player_bets', { params });
  return data;
};

export const apiCancelBet = async ({ unitToken, wagerSetId }) => {
  const { data } = await axios.put('lotteries/cancel_bet', {
    token: unitToken,
    wager_set_id: wagerSetId,
  });
  return data;
};

export const apiCancelSubscription = async ({ unitToken, subscriptionId }) => {
  const { data } = await axios.put('lotteries/bet_subscriptions/cancel', {
    token: unitToken,
    subscription_id: subscriptionId,
  });
  return data;
};

export const apiGetCart = async ({ unitToken }) => {
  const { data } = await axios.get('lotteries/cart', {
    params: { token: unitToken },
  });
  return data;
};

export const apiSaveCart = async ({ unitToken, cart }) => {
  const { data } = await axios.put('lotteries/cart', {
    token: unitToken,
    cart,
  });
  return data;
};

export const apiDeleteCart = async ({ unitToken }) => {
  const { data } = await axios.delete('lotteries/cart', {
    data: { token: unitToken },
  });
  return data;
};
